<template>
  <main role="main">
    <div class="container py-4" style="max-width:700px;">
      <h4 class="mb-4">{{ $t("changeWebPort") }}</h4>
      <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
      <b-form v-if="!isLoading && currentPortPolicy" @keydown="formKeyDown" @submit.prevent="submitForm">

        <b-form-group label-for="input-port">
          <template v-slot:label>Port <span class="text-danger">*</span></template>
          <b-form-input id="input-port" type="number" required min="1" max="65535"
                        v-model="port" name="port"></b-form-input>
        </b-form-group>

        <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

        <div class="text-center pt-3">
          <b-button type="submit" variant="primary" style="width: 120px;"
                    :disabled="isSubmitting" @click="beforeSubmit">{{ $t("save") }}</b-button>
        </div>

      </b-form>
    </div>
  </main>
</template>

<style lang="scss" scoped>

</style>


<script lang="ts">
  import {Component, Emit, Prop} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as portPolicyService from "@/service/portPolicyService";

  @Component
  export default class PortPolicy extends BaseComponent {

    isLoading = true;

    currentPortPolicy=null;

    port = 8080;

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}

    mounted(){
      this.fetchPortPolicy();
    }

    async fetchPortPolicy(){
      try{
        this.isLoading = true;
        this.currentPortPolicy = await portPolicyService.get();
        Object.assign(this, this.currentPortPolicy);

      } catch (e) {
        console.error(e);

      } finally {
        this.isLoading = false;
      }

    }

    formKeyDown(event) {
      return event.key !== 'Enter';
    }

    beforeSubmit(){
      //const trimFields = ["cronJobSchedule", "ftpHost", "ftpUser","ftpPassword","ftpPath"];
      //for (const field of trimFields) {
      //  this[field] = this[field].trim();
      //}

    }

    async submitForm(){
      try{
        this.isSubmitting = true;

        const body = {
          port: +this.port,
        };
        await portPolicyService.set(body);
        this.toastSuccessDelay(this.$t("saveSettingsSuccessful").toString(), null, 0);
        this.fetchPortPolicy();


      }catch(e){
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }

</script>
